import request from '@/utils/request';

/**
 * 平台配置 - 装修模板库 - start
 */

/**
 * 获取平台模版列表
 * @param {*} params
 * @returns
 */
export function getPlatformTemplateList(params) {
  return request({
    url: '/decoration/template/get-platform-template',
    method: 'get',
    params: params
  });
}

/**
 * 删除平台模板
 * @param {*} data
 * @returns
 */
export function delPlatformTemplate(data, module) {
  var url = {
    platform: '/decoration/template/platform-template-del',
    channel: '/decoration/template/channel-template-del'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

/**
 * 获取组件列表 - 装修模板库
 * @param {*} params
 * @returns
 */
export function getComponents(params, module) {
  var url = {
    platform: '/decoration/template/get-widget',
    mall: '/decoration/template/get-mall-widget',
    channel: '/decoration/template/get-channel-widget'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取菜单列表 - 装修模板库
 * @param {*} params
 * @returns
 */
export function getCategory(params, module) {
  var url = {
    platform: '/decoration/template/get-category',
    mall: '/decoration/template/get-mall-category',
    channel: '/decoration/template/get-channel-category'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 获取模版-查看
 * @param {*} params
 * @returns
 */
export function getDetail(params, module) {
  var url = {
    platform: '/decoration/template/platform-template-edit',
    // 平台模板库
    mall: '/decoration/template/mall-template-edit',
    // 商城管理模板库
    channel: '/decoration/template/channel-template-edit' //渠道模板库
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 创建模板
 * @param {*} data
 * @returns
 */
export function createTemplate(data, type, module) {
  var url = {
    create: {
      platform: '/decoration/template/platform-template-create',
      mall: '/decoration/template/mall-template-create'
    },
    update: {
      platform: '/decoration/template/platform-template-edit',
      mall: '/decoration/template/mall-template-edit',
      channel: '/decoration/template/channel-template-edit'
    }
  }[type][module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 创建平台模板 - 获取装修信息 style_id
 * @param {*} params
 * @returns
 */
export function getCreateTemplateDetail(params, module) {
  var url = {
    platform: '/decoration/template/platform-template-create',
    mall: '/decoration/template/mall-template-create'
  }[module];
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 平台配置 - 装修保存单个组件
 * @param {*} data
 * @returns
 */
export function update(data, module) {
  var url = {
    platform: '/decoration/template/update',
    mall: '/decoration/template/mall-update',
    channel: '/decoration/template/channel-update'
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
/**
 * 平台配置 - 装修模板库 - end
 */

/**
 * 平台配置 - 渠道 - 装修模板库 - start
 */

/**
 * 获取搜索项中渠道列表
 * @param {*} params
 * @returns
 */
export function getChannel(params) {
  return request({
    url: '/decoration/template/get-channel-template-search',
    method: 'get',
    params: params
  });
}
/**
 * 获取渠道模版列表
 * @param {*} params
 * @returns
 */
export function getChannelTemplateList(params) {
  return request({
    url: '/decoration/template/get-channel-template',
    method: 'get',
    params: params
  });
}
/**
 * 平台配置 - 选为平台模版
 * @param {*} data
 * @returns
 */
export function copyChannelTemplate(data) {
  return request({
    url: '/decoration/template/copy-channel-template-platform',
    method: 'post',
    data: data
  });
}
/**
 * 平台配置 - 渠道 - 装修模板库 - end
 */

/**
 * 商城管理 - 装修模板库 - start
 */

/**
 * 商城管理 - 获取模版列表
 * @param {*} params
 * @returns
 */
export function getMallTemplateList(params) {
  return request({
    url: '/decoration/template/get-mall-template',
    method: 'get',
    params: params
  });
}
/**
 * 商城管理 - 删除模板
 * @param {*} data
 * @returns
 */
export function delMallTemplate(data) {
  return request({
    url: '/decoration/template/mall-template-del',
    method: 'post',
    data: data
  });
}
/**
 * 商城管理 - 复制为渠道模版
 * @param {*} data
 * @returns
 */
export function copyMallChannelTemplate(data) {
  return request({
    url: '/decoration/template/copy-platform-template-channel',
    method: 'post',
    data: data
  });
}
/**
 * 商城管理 - 复制为平台模版
 * @param {*} data
 * @returns
 */
export function copyMallPlatformTemplate(data) {
  return request({
    url: '/decoration/template/copy-channel-template-platform',
    method: 'post',
    data: data
  });
}

/**
 * 查看客户名称
 * @param {*} params
 * @returns
 */
export function showCustomerName(params) {
  return request({
    url: '/decoration/template/show-customer-name',
    method: 'get',
    params: params
  });
}

/**
 * 商城管理 - 装修模板库 - end
 */

/**
 * 获取组件列表
 * @param {*} params
 * @returns
 */
export function getWidget(params) {
  return request({
    url: '/decoration/decoration-picture/get-widget',
    method: 'get',
    params: params
  });
}
/**
 * 获取装修图库分类菜单列表
 * @param {*} params
 * @returns
 */
export function getPictureTypeTree(params) {
  return request({
    url: '/decoration/decoration-picture/get-picture-type-tree-new',
    method: 'get',
    params: params
  });
}
/**
 * 保存组件绑定图库
 * @param {*} data
 * @returns
 */
export function save(data) {
  return request({
    url: '/decoration/decoration-picture/save-decoration-picture-type',
    method: 'post',
    data: data
  });
}

// 获取卡类型管理列表
export function getCardTypeList(data) {
  return request({
    url: '/orders/plat-card-bin/list',
    method: 'post',
    data: data
  });
}
// 获取卡类型渠道列表
export function getPlatChannelList(data) {
  return request({
    url: '/orders/plat-card-bin/channel-list',
    method: 'post',
    data: data
  });
}
// 获取卡类型管理业务类型
export function getPlatCardGroupList(params) {
  return request({
    url: '/orders/plat-card-bin/group-list',
    method: 'get',
    params: params
  });
}
// 获取卡类型管理卡类型
export function getPlatCardTypeList(data) {
  return request({
    url: '/orders/plat-card-bin/card-list',
    method: 'post',
    data: data
  });
}
// 删除卡类型
export function delCardType(data) {
  return request({
    url: '/orders/plat-card-bin/del-card-bin',
    method: 'post',
    data: data
  });
}
// 获取应用场景列表
export function getPackageUsageList(params) {
  return request({
    url: '/package/package-usage/index',
    method: 'get',
    params: params
  });
}
// 添加应用场景
export function addPackageUsage(data) {
  return request({
    url: '/package/package-usage/create',
    method: 'post',
    data: data
  });
}
// 删除应用场景
export function delPackageUsage(params) {
  return request({
    url: '/package/package-usage/delete',
    method: 'get',
    params: params
  });
}
// 获取默认菜单
export function getPackUsageMenus(params) {
  return request({
    url: '/package/package-usage/package-menus',
    method: 'get',
    params: params
  });
}
// 编辑应用场景
export function editPackageUsage(data) {
  return request({
    url: '/package/package-usage/to-update',
    method: 'post',
    data: data
  });
}

// 获取订单列表
export function getOrderList(data) {
  return request({
    url: '/plat/order/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取渠道列表
export function getChannelList(data) {
  return request({
    url: '/plat/channel/list',
    method: 'post',
    data: data
  });
}
// 短信模板管理-列表
export function getSmsTemplateList(params) {
  return request({
    url: '/plat/sms-template/get-sms-template-list',
    method: 'get',
    params: params
  });
}
// 短信模板管理-搜索项
export function getSmsTemplateSearch(params) {
  return request({
    url: '/plat/sms-template/get-sms-template-search',
    method: 'get',
    params: params
  });
}
// 短信模板管理-详情
export function getSmsTemplateDetails(params) {
  return request({
    url: '/plat/sms-template/get-sms-template',
    method: 'get',
    params: params
  });
}
// 短信模板管理-详情
export function delSmsTemplate(params) {
  return request({
    url: '/plat/sms-template/delete-sms-template',
    method: 'get',
    params: params
  });
}
// 短信模板管理-渠道
export function getSmsChannelList(data) {
  return request({
    url: '/orders/channel/list',
    method: 'post',
    data: data
  });
}
// 短信模板管理-公司
export function getSmsAccountList(params) {
  return request({
    url: 'orders/card-info/get-account-list',
    method: 'get',
    params: params
  });
}
// 短信模板管理-创建短信模版
export function createSmsTemplate(data) {
  return request({
    url: '/plat/sms-template/create-sms-template',
    method: 'post',
    data: data
  });
}
// 短信模板管理-编辑短信模版
export function updateSmsTemplate(data) {
  return request({
    url: '/plat/sms-template/update-sms-template',
    method: 'post',
    data: data
  });
}

/**
 * 获取标签管理列表
 * @param {*} params
 * @returns
 */
export function getTags(params) {
  return request({
    url: '/plat/tags/index',
    method: 'get',
    params: params
  });
}

/**
 * 添加标签
 * @param {*} data
 * @returns
 */
export function createTag(data) {
  return request({
    url: '/plat/tags/create',
    method: 'post',
    data: data
  });
}

/**
 * 删除标签
 * @param {*} params
 * @returns
 */
export function removeTag(params) {
  return request({
    url: '/plat/tags/delete',
    method: 'get',
    params: params
  });
}
/**
 * 编辑  中影线下刷卡
 * @param {*} params
 * @returns
 */
export function setZyOffline(data) {
  return request({
    url: '/orders/plat-card-bin/set-zy-offline',
    method: 'post',
    data: data
  });
}

// 我的商城账号列表
export function getShopAccount(params) {
  return request({
    url: '/user/shop-account/index',
    method: 'get',
    params: params
  });
}

// 绑卡
export function bindCard(data) {
  return request({
    url: '/orders/test-cards/bind-card',
    method: 'post',
    data: data
  });
}

//验收-基本信息
export function getTestCardInfo(params) {
  return request({
    url: '/orders/test-cards/index',
    method: 'get',
    params: params
  });
}

// 获取渠道公众号二维码
export function getLoginUrl(params) {
  return request({
    url: '/user/channel/get-login-url',
    method: 'get',
    params: params
  });
}
// 获取渠道小程序二维码
export function getLoginImg(params) {
  return request({
    url: '/user/channel/get-login-img',
    method: 'get',
    params: params
  });
}

// 用户信息 - 获取渠道用户绑卡信息
export function getUserCardList(params) {
  return request({
    url: '/user/channel-user/channel-user-card-list',
    method: 'get',
    params: params
  });
}

//类型列表
export function searchTypes(params) {
  return request({
    url: '/orders/shop-orders/search-types',
    method: 'get',
    params: params
  });
}

// 订单列表
export function orderList(params) {
  return request({
    url: '/orders/shop-orders/list',
    method: 'get',
    params: params
  });
}

// 更改账号状态
export function changeUserStataus(data) {
  return request({
    url: '/orders/test-cards/change-user-status',
    method: 'post',
    data: data
  });
}

// 获取模拟登录地址
export function getMockLoginUrl(data) {
  return request({
    url: '/orders/test-cards/mock-login',
    method: 'post',
    data: data
  });
}
// 提示信息管理列表
export function getPromptMsgList(params) {
  return request({
    url: '/user/page-description-manage/index',
    method: 'get',
    params: params
  });
}
// 提示信息管理-更新
export function updatePromptMsg(data) {
  return request({
    url: '/user/page-description-manage/to-update',
    method: 'post',
    data: data
  });
}